export default __webpack_public_path__ + "static/media/XRP.7bdbdbf3.svg";